import { render, staticRenderFns } from "./GlyphTabSidebar.vue?vue&type=template&id=36622de5&scoped=true&"
import script from "./GlyphTabSidebar.vue?vue&type=script&lang=js&"
export * from "./GlyphTabSidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36622de5",
  null
  
)

export default component.exports